import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const AssignmentResponsesPageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled.div`
  flex: 1;
  margin-left: 0;
  background: white;
  border-radius: ${pxToRem(16)};
  box-shadow: 0px ${pxToRem(9)} ${pxToRem(14.5)} rgba(0, 0, 0, 0.06),
    0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  padding: ${pxToRem(32)} ${pxToRem(25)};
  box-sizing: border-box;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  margin-bottom: ${pxToRem(32)};
`;

export const Title = styled.h1`
  font-size: ${pxToRem(32)};
  font-weight: 700;
  color: rgb(31, 10, 53);
`;

export const Counter = styled.div`
  color: rgb(31, 10, 53);
  font-size: ${pxToRem(28)};
  font-weight: 600;
`;

export const StatsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  width: 100%;
  padding: ${pxToRem(16)} ${pxToRem(16)} ${pxToRem(16)} ${pxToRem(38)};
  gap: ${pxToRem(10)};
  border-radius: ${pxToRem(16)};
  box-shadow: 0px ${pxToRem(9)} ${pxToRem(14.5)} 0px rgba(0, 0, 0, 0.06),
    0px 0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  background: rgb(255, 255, 255);
`;

export const StatBlock = styled.div`
  color: rgba(31, 10, 53, 0.5);
  font-size: ${pxToRem(16)};
  font-weight: 400;
`;
